import React, { useEffect, useState } from 'react'
import { formatDate } from '@/common/time'
import { MachineName } from '@/components/machine'
import { Order, OrderManager } from '@/components/order/Order'
import { StaticPaginatedTable, StaticPaginatedTableState } from '@/components/search/StaticPaginatedTable'
import { SearchCriteria, SearchCriteriaParams } from '@/pages/communal/statistics/components/common/searchCriteria'
import { MachineType } from '@/services/model/machine'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'

interface ActiveCounterPopupProps {
  services: Services
  session: CurrentSession
  criteria: SearchCriteria
  bucketFor: Date
  goToMachinePage: (machineId: string) => void
  onClose: () => void
}

interface ActiveMachine {
  imei: string
  machine: {
    id: string
    imei: string
    internalNumber: string
    type: MachineType
  }
}

const ActiveCounterPopupOrderCols = ['machine.internalNumber']
const ActiveCounterPopupDefaultOrder: Order = {
  key: 'machine.internalNumber',
  asc: true
}

export const ActiveCounterPopupBody = ({ services, session, criteria, bucketFor, goToMachinePage, onClose }: ActiveCounterPopupProps) => {
  const bucketForTime = bucketFor.getTime()
  const [response, setResponse] = useState<ActiveMachine[]>()
  const [listState, setListState] = useState<StaticPaginatedTableState>({ pageNumber: 1, pageSize: 10 })
  const [orderManager, setOrderManager] = useState<OrderManager>(() => new OrderManager(
    ActiveCounterPopupOrderCols,
    ActiveCounterPopupDefaultOrder,
    (order: Order) => {
      setOrderManager((current) => current.newManager(order))
      setListState((current) => ({ ...current, pageNumber: 1 }))
    }
  ))

  useEffect(() => {
    setResponse(undefined)
    services.session
      .fetchWithToken(`/api/communal/statistics/machines/bucket/active?bucketFor=${new Date(bucketForTime).toISOString()}&${SearchCriteriaParams(criteria)}`)
      .then((r) => r.json())
      .then(setResponse)
  }, [services.session, criteria, bucketForTime])

  if (!response) {
    return <div className='spinner'></div>
  }

  return <div>
    <h3>{formatDate(bucketFor)}</h3>
    <StaticPaginatedTable<ActiveMachine>
      data={orderManager.orderListByKey(response)}
      parentState={listState}
      setParentState={setListState}
      header={() => <div className='hcol' onClick={() => orderManager.click('machine.internalNumber')}>
        {session.translates.for('elements.table.maxhitpop.machine')}
        {orderManager.orderInfoElement('machine.internalNumber')}
      </div>}
      row={(row) => <div className='col' onClick={() => {
        goToMachinePage(row.machine.id)
        onClose()
      }}><MachineName row={row.machine} /></div>}
      translates={session.translates}
    />
  </div>
}
